/*
 * WW Sigma Hero — background loop + "Watch full video" YouTube popup
 * Author: Plaud Tayler — 2026-07-20
 * Version: 2.3.0 - 2026-07-28 19:40 (UTC+8) - Plaud Tayler — rotator pacing: dwell 2s, roll 0.4s (was 3s/0.6s — too slow). Title rotator (IO-gated cycle,
 * reduced-motion off). Also: ≤1024 mobile video swap (data-mobile-src); YouTube popup with
 * src assigned on open / cleared on close. Document-delegated listeners survive hot-reloads.
 */
(function () {
  if (window.__wwSigmaHero) return;
  window.__wwSigmaHero = true;

  var lastTrigger = null;
  var releaseTrap = null;

  function modalFor(el) {
    var section = el.closest('.ww-sigma-hero');
    return section ? section.querySelector('[data-hero-modal]') : null;
  }

  function openModal(modal, trigger) {
    var iframe = modal.querySelector('iframe[data-yt-src]');
    if (iframe && !iframe.getAttribute('src')) iframe.setAttribute('src', iframe.getAttribute('data-yt-src'));
    modal.hidden = false;
    document.documentElement.classList.add('ww-sigma-hero-modal-open');
    lastTrigger = trigger || null;
    var closeBtn = modal.querySelector('.ww-sigma-hero__yt-close');
    if (closeBtn) closeBtn.focus();
    /* Tab cycling locked inside the dialog (reuses global.js trapFocus, W2 fix) - Plaud Tayler - 2026-08-05 18:10 */
    if (typeof trapFocus === 'function') releaseTrap = trapFocus(modal);
  }

  function closeModal(modal) {
    var iframe = modal.querySelector('iframe[data-yt-src]');
    if (iframe) iframe.removeAttribute('src'); /* stops YouTube playback outright */
    modal.hidden = true;
    document.documentElement.classList.remove('ww-sigma-hero-modal-open');
    if (typeof releaseTrap === 'function') { releaseTrap(); releaseTrap = null; }
    if (lastTrigger) { lastTrigger.focus(); lastTrigger = null; }
  }

  document.addEventListener('click', function (e) {
    var watch = e.target.closest('[data-hero-watch]');
    if (watch) {
      var modal = modalFor(watch);
      if (modal) openModal(modal, watch);
      return;
    }
    var closer = e.target.closest('[data-hero-modal-close]');
    if (closer) {
      var m = closer.closest('[data-hero-modal]');
      if (m) closeModal(m);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('[data-hero-modal]:not([hidden])');
    if (open) closeModal(open);
  });

  // Mobile video source — perf audit P0-3 (2026-07-28): the LCP element is this video; ≤1024 swaps in
  // the lighter mobile clip (data-mobile-src on the [data-hero-video] wrapper) instead of the
  // 1080p desktop file. Desktop src captured on first swap so crossing back restores it.
  // - Plaud Tayler
  var heroMq = window.matchMedia('(max-width: 1024px)');
  function applyHeroSource() {
    var wrap = document.querySelector('[data-hero-video][data-mobile-src]');
    if (!wrap) return;
    var v = wrap.querySelector('video');
    if (!v) return;
    if (!wrap.__desktopSrc) wrap.__desktopSrc = v.currentSrc || (v.querySelector('source') && v.querySelector('source').src) || '';
    var want = heroMq.matches ? wrap.getAttribute('data-mobile-src') : wrap.__desktopSrc;
    if (!want || v.__appliedSrc === want) return;
    v.__appliedSrc = want;
    while (v.firstChild) v.removeChild(v.firstChild); /* drop <source> list — src attr wins */
    v.src = want;
    v.load();
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  if (heroMq.addEventListener) heroMq.addEventListener('change', applyHeroSource);

  // Title rotator (redesign 2026-07-28): heading → taglines cycle in one left
  // slot. Runs ONLY while the hero is on screen (IntersectionObserver, Rule 6) and never
  // under prefers-reduced-motion (CSS keeps the static heading). Dwell from data-dwell-ms
  // (schema, merchant-tunable). - Plaud Tayler
  var reducedMq = window.matchMedia('(prefers-reduced-motion: reduce)');
  function initRotator() {
    var rot = document.querySelector('[data-hero-rotator]');
    if (!rot || rot.__wired || reducedMq.matches) return;
    var phrases = rot.querySelectorAll('.ww-sigma-hero__phrase');
    if (phrases.length < 2) return;
    rot.__wired = true;
    var i = 0;
    var dwell = parseInt(rot.getAttribute('data-dwell-ms'), 10) || 3000;
    var timer = null;
    function step() {
      var cur = phrases[i];
      i = (i + 1) % phrases.length;
      var nxt = phrases[i];
      cur.classList.remove('is-current');
      cur.classList.add('is-leaving'); // rolls down + fades
      setTimeout(function () { cur.classList.remove('is-leaving'); }, 500); // reset above, invisible (0.4s transition + margin)
      nxt.classList.add('is-current'); // drops in from above
    }
    function start() { if (!timer) timer = setInterval(step, dwell); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    var hero = rot.closest('.ww-sigma-hero');
    if (typeof IntersectionObserver !== 'undefined' && hero) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { start(); } else { stop(); } });
      }, { threshold: 0.15 }).observe(hero);
    } else {
      start();
    }
  }

  function heroInit() { applyHeroSource(); initRotator(); }
  if (document.readyState !== 'loading') heroInit();
  else document.addEventListener('DOMContentLoaded', heroInit);
  document.addEventListener('shopify:section:load', heroInit);
})();
